<template>
  <div style="background-color: #f5f5f5;">
    <div class="head"></div>
    <div class="w">
      <div class="content">
        <div class="left">
          <h2 class="menu_head">{{ menuHead }}</h2>
          <h3 class="menu_head2">{{ menuHead2 }}</h3>
          <ul class="menu_list">
            <li
              v-for="(item, index) in menuList"
              :key="item.id"
              @click="clickMenu(item)"
            >
              <span
                class="jiantou"
                :class="{ down: item.showHeight }"
                @click="jiantou(item)"
                v-if="item.child && item.child.length > 0"
              ></span>
              {{ item.menuName }}
              <ul
                v-if="item.child && item.child.length > 0"
                :class="{ showHeight: item.showHeight }"
              >
                <li
                  v-for="item2 in item.child"
                  :key="item2.id"
                  @click="clickMenu(item2)"
                >
                  {{ item2.menuName }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="right">
          <div class="breadcrumb">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item
                v-for="item in menuPath"
                :to="{ path: item.menuUrl }"
                :key="item.menuId"
                >{{ item.menuName }}</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiService, RESULT_CODE } from "@/api/ApiService.js";
export default {
  name: "ArticleInit",
  mounted() {
    this.init();
  },
  watch: { $route: "init" },
  computed: {
    menuHead: {
      get() {
        return this.menuPath[0] ? this.menuPath[0].menuName : "";
      }
    },
    menuHead2: {
      get() {
        if (!this.menuPath || this.menuPath.length == 0) {
          return "";
        } else if (this.menuPath.length == 1) {
          return this.menuPath[0].menuName;
        } else {
          return this.menuPath[1].menuName;
        }
      }
    },
    menuList: {
      get() {
        if (this.menuPath.length >= 2) {
          return this.menuPath[1].child;
        } else {
          return [];
        }
      },
      set(val) {
        if (this.menuPath.length >= 2) {
          this.menuPath[1].child = val;
        }
      }
    }
  },
  data() {
    return {
      menuPath: [],
      abc: ""
    };
  },
  methods: {
    init() {
      let { articleModel, articleId } = this.$route.query;
      let menuPath = [];
      apiService.findAllMenu().then(res => {
        this.getMenuPath(res.data, articleModel, menuPath);
        this.menuPath = menuPath;
      });
    },
    getMenuPath(menuList, menuId, menuPath) {
      for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].menuId == menuId) {
          menuPath.push(menuList[i]);
          return true;
        }
      }

      for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].child && menuList[i].child.length > 0) {
          menuPath.push(menuList[i]);
          let f = this.getMenuPath(menuList[i].child, menuId, menuPath);
          if (!f) {
            menuPath.splice(menuPath.length - 1, 1);
          } else {
            return true;
          }
        }
      }

      return false;
    },
    clickMenu(item) {
      console.log("item:", item);
      if (!item.child || item.child.length == 0) {
        // this.$router.push(item.menuUrl)
        this.$router.push(item.menuUrl);
      }
    },
    jiantou(item) {
      this.$set(item, "showHeight", !item.showHeight);
    }
  }
};
</script>
<style scoped>
.head {
  height: 1.5rem;
  background-image: url("../assets/imgs/plbj.png");

  background-size: 100% 100%;
}
.content {
  display: flex;
}
.content > .left {
  text-align: center;
  width: 1.3rem;
}
.menu_head {
  background-color: #b93c28;
  color: #fff;
  line-height: 0.425rem;
  font-size: 0.12rem;
  font-weight: 400;
}
.menu_head2 {
  line-height: 0.25rem;
  font-size: 0.09rem;
  font-weight: 400;
  color: #fff;
  margin-top: 0.025rem;
  background: rgb(5, 115, 184);
}
.content > .right {
  flex: 1;
  margin-left: 0.15rem;
}
.breadcrumb {
  background-color: #fff;
  box-sizing: border-box;
  padding: 0.05rem 0.1rem;
  margin-top: 0.025rem;
  border-radius: 0.05rem;
}
.menu_list {
  margin-top: 10px;
}
.menu_list > li {
  line-height: 0.275rem;
  text-align: center;
  background: #dee2eb;
  color: rgb(24 110 165);
  cursor: pointer;
  position: relative;
}
.menu_list li:hover {
  background: #fff;
}
.menu_list > li > ul {
  position: relative;
}
.menu_list > li > ul > li {
  line-height: 0;
  overflow: hidden;
  background-color: #e2f5fa;
  transition: all 0.5s;
}
.showHeight > li {
  line-height: 0.275rem !important;
}
.jiantou {
  position: absolute;
  width: 0.025rem;
  height: 0.025rem;
  border: 0.02rem solid #333;
  border-left-color: transparent;
  border-top-color: transparent;
  transition: transform 0.5s, -webkit-transform 0.5s;
  transform: rotate(-45deg);
  top: 0.1rem;
  right: 0.1rem;
}
.jiantou.down {
  transform: rotate(45deg);
}

@media screen and (max-width: 768px) {
  .content .left {
    display: none;
  }
  .content > .right {
    margin: 0;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleInit.vue